import React from 'react';
import { FaPenAlt } from 'react-icons/fa';
import { formatDistance } from 'date-fns';
import PtBrLocale from 'date-fns/locale/pt-BR';

import { Container } from './styles';
import { useHistory } from 'react-router';
import { subpoenaPath } from '../notifications';

function NotificationItem({ image, title, description, createdAt }) {
  const { push } = useHistory();

  return (
    <Container
      image={image}
      onClick={() => {
        push(subpoenaPath);
      }}
    >
      {image && <div className="image" />}
      <div className="info-container">
        <div className="details">
          <h3>{title}</h3>
          <span>{description}</span>
        </div>

        <div className="date">
          <FaPenAlt />

          <span>
            {formatDistance(createdAt, new Date(), {
              locale: PtBrLocale,
            })}
          </span>
        </div>
      </div>
    </Container>
  );
}

export default NotificationItem;
